import React from "react";
import GenericCard from "components/UI/GenericCard/GenericCard";
import { Card, Row, Col, Statistic } from "antd";
import { BankOutlined } from "@ant-design/icons";

const IBAccountDetails = ({ accountData, showSensitiveValues }) => {
  const formatCurrency = (value) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  };

  const maskValue = (value) => {
    if (!showSensitiveValues && typeof value === "number") {
      return "••••••";
    }
    return value;
  };

  return (
    <GenericCard
      title="Account Details"
      tooltipText="Current account information from Interactive Brokers"
    >
      <div style={{ padding: "16px 0" }}>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} lg={4}>
            <Card size="small">
              <Statistic
                title="Account ID"
                value={`${accountData.account_id} (${
                  accountData.account_type === "live" ? "Live" : "Paper"
                })`}
                prefix={<BankOutlined />}
                valueStyle={{ fontSize: "16px", fontWeight: "bold" }}
              />
            </Card>
          </Col>
          <Col xs={24} sm={12} lg={4}>
            <Card size="small">
              <Statistic
                title="Cash Balance"
                value={maskValue(accountData.cash_balance)}
                formatter={(value) =>
                  showSensitiveValues ? formatCurrency(value) : value
                }
                valueStyle={{
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
              />
            </Card>
          </Col>
          <Col xs={24} sm={12} lg={4}>
            <Card size="small">
              <Statistic
                title="Excess Liquidity"
                value={maskValue(accountData.excess_liquidity)}
                formatter={(value) =>
                  showSensitiveValues ? formatCurrency(value) : value
                }
                valueStyle={{
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
              />
            </Card>
          </Col>
          <Col xs={24} sm={12} lg={4}>
            <Card size="small">
              <Statistic
                title="Net Liquidation"
                value={maskValue(accountData.net_liquidation)}
                formatter={(value) =>
                  showSensitiveValues ? formatCurrency(value) : value
                }
                valueStyle={{
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
              />
            </Card>
          </Col>
          <Col xs={24} sm={12} lg={4}>
            <Card size="small">
              <Statistic
                title="Invested Capital"
                value={maskValue(accountData.invested_capital)}
                formatter={(value) =>
                  showSensitiveValues ? formatCurrency(value) : value
                }
                valueStyle={{
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
              />
            </Card>
          </Col>
          <Col xs={24} sm={12} lg={4}>
            <Card size="small">
              <Statistic
                title="Unrealized P&L"
                value={maskValue(accountData.unrealized_pnl)}
                formatter={(value) =>
                  showSensitiveValues ? formatCurrency(value) : value
                }
                valueStyle={{
                  fontSize: "16px",
                  fontWeight: "bold",
                  color:
                    showSensitiveValues && accountData.unrealized_pnl !== 0
                      ? accountData.unrealized_pnl > 0
                        ? "#52c41a"
                        : "#ff4d4f"
                      : "",
                }}
              />
            </Card>
          </Col>
        </Row>
      </div>
    </GenericCard>
  );
};

export default IBAccountDetails;
